import React from 'react';
import { motion } from 'framer-motion';
import './Pricing.css';

const plans = [
  {
    title: 'Hourly Booking',
    price: 'Starting at ₹199/hr',
    items: ['Verified Driver', 'Live Tracking', 'Free Cancellation'],
    outline: false,
  },
  {
    title: 'Daily Booking',
    price: 'Starting at ₹1499/day',
    items: ['Includes Hourly features', 'Unlimited Stops', 'Priority Support'],
    outline: true,
    popular: true,
  },
  {
    title: 'Monthly Booking',
    price: 'Starting at ₹39,999/month',
    items: ['Dedicated Driver', 'Fixed Monthly Rate', 'Priority Scheduling'],
    outline: false,
  },
  {
    title: 'Outstation',
    price: 'Starting at ₹14/km',
    items: ['Professional Driver', 'Multi-day Booking', 'Night Travel'],
    outline: false,
  },
];

export default function Pricing() {
  return (
    <section id="pricing" className="section pricing">
      <motion.h2
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        Pricing
      </motion.h2>
      <motion.p
        className="pricing-sub"
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.08 }}
      >
        Choose a plan that fits your needs
      </motion.p>

      <div className="pricing-grid">
        {plans.map((plan, i) => (
          <motion.div
            className={`price-card${plan.popular ? ' popular' : ''}`}
            key={plan.title}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ y: -8, scale: 1.02 }}
          >
            {plan.popular && <div className="badge">Most Popular</div>}
            <div className="price-head">{plan.title}</div>
            <div className="price">{plan.price}</div>
            <ul>
              {plan.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <button className={`btn primary${plan.outline ? ' outline' : ''}`}>Book Now</button>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
